/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JtlOrderView } from '../models/JtlOrderView';
import type { MoneyView } from '../models/MoneyView';
import type { OrderListView } from '../models/OrderListView';
import type { OrderShortView } from '../models/OrderShortView';
import type { ShopifyOrderView } from '../models/ShopifyOrderView';
import type { ShopifyStatisticsSummaryView } from '../models/ShopifyStatisticsSummaryView';
import type { ShopInfoView } from '../models/ShopInfoView';
import type { StatisticsSummaryView } from '../models/StatisticsSummaryView';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileShopService {
    /**
     * Get orders list
     * Get orders for shop with filters
     * @param shopId
     * @param requestBody Array of filters
     * @returns any Orders list
     * @throws ApiError
     */
    public static postAppMobileShopOrders(
        shopId: string,
        requestBody?: Array<{
            key?: 'period' | 'startDate' | 'endDate' | 'order' | 'status' | 'page' | 'limit';
            value?: string;
        }>,
    ): CancelablePromise<Array<(JtlOrderView | ShopifyOrderView)>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/orders',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get orders count
     * Get orders count for shop with filters
     * @param shopId
     * @param requestBody Array of filters
     * @returns number Orders count
     * @throws ApiError
     */
    public static postAppMobileShopOrdersCount(
        shopId: string,
        requestBody?: Array<{
            key?: string;
            value?: string;
        }>,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/orders/count',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get orders total
     * Get orders total amount for shop with filters
     * @param shopId
     * @param requestBody Array of filters
     * @returns MoneyView Orders total
     * @throws ApiError
     */
    public static postAppMobileShopOrdersTotal(
        shopId: string,
        requestBody?: Array<{
            key?: string;
            value?: string;
        }>,
    ): CancelablePromise<MoneyView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/orders/total',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get orders short list
     * Get orders in short format for shop with filters
     * @param shopId
     * @param requestBody Array of filters
     * @returns OrderShortView Orders short list
     * @throws ApiError
     */
    public static postAppMobileShopOrdersShort(
        shopId: string,
        requestBody?: Array<{
            key?: string;
            value?: string;
        }>,
    ): CancelablePromise<Array<OrderShortView>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/orders/short',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get orders list
     * Get detailed orders list with items, addresses, customer data. Works for JTL (JtlOrderView) and Shopify (ShopifyOrderView) shops.
     * @param shopId
     * @param requestBody Array of filters
     * @returns OrderListView Orders list with pagination
     * @throws ApiError
     */
    public static postAppMobileShopOrdersList(
        shopId: string,
        requestBody?: Array<{
            key?: 'period' | 'startDate' | 'endDate' | 'order' | 'status' | 'page' | 'limit';
            value?: string;
        }>,
    ): CancelablePromise<OrderListView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/orders/list',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get order by ID
     * Get single order by ID
     * @param shopUuid
     * @param orderId
     * @returns any Order data
     * @throws ApiError
     */
    public static getAppMobileShopOrder(
        shopUuid: string,
        orderId: number,
    ): CancelablePromise<(JtlOrderView | ShopifyOrderView)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/api/mobile/shop/order',
            query: {
                'shopUUID': shopUuid,
                'orderID': orderId,
            },
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get shop info
     * Get shop info (orders count, total, visitors, etc.)
     * @param shopId
     * @param noConnectionCheck If true, omit connection check to speed up fetching
     * @param requestBody Array of filters
     * @returns ShopInfoView Shop info
     * @throws ApiError
     */
    public static postAppMobileShopInfo(
        shopId: string,
        noConnectionCheck: boolean = false,
        requestBody?: Array<{
            key?: string;
            value?: string;
        }>,
    ): CancelablePromise<ShopInfoView> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/info',
            query: {
                'shopID': shopId,
                'noConnectionCheck': noConnectionCheck,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
    /**
     * Get statistics summary
     * Get statistics summary for a shop. JTL shops return StatisticsSummaryView (full data from plugin). Shopify shops return ShopifyStatisticsSummaryView (aggregated from GraphQL orders — some fields like visitors, abandoned carts, payment methods are not available).
     * @param shopId
     * @param requestBody Array of filters (period, startDate, endDate, limit)
     * @returns any Statistics summary (JTL: StatisticsSummaryView, Shopify: ShopifyStatisticsSummaryView)
     * @throws ApiError
     */
    public static postAppMobileShopStatisticsSummary(
        shopId: string,
        requestBody?: Array<{
            key?: 'period' | 'startDate' | 'endDate' | 'limit';
            value?: string;
        }>,
    ): CancelablePromise<(StatisticsSummaryView | ShopifyStatisticsSummaryView)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/statistics/summary',
            query: {
                'shopID': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error (e.g. shop not found)`,
            },
        });
    }
    /**
     * Get all enabled shops info
     * Get shop info for all enabled shops (orders count, total, visitors, isOnline, etc.)
     * @param requestBody Array of filters (applied to all shops)
     * @returns ShopInfoView List of shop info
     * @throws ApiError
     */
    public static postAppMobileShopInfoList(
        requestBody?: Array<{
            key?: string;
            value?: string;
        }>,
    ): CancelablePromise<Array<ShopInfoView>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v2/api/mobile/shop/info/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Error`,
            },
        });
    }
}
